import {
  BusinessIcon,
  ExpediaFunIcon,
  FamilyIcon,
  FriendsIcon,
  HeartIcon,
  ProfileIcon,
} from '@assets/icons';

const REVİEW_TYPES = {
  // Plane transportation types
  BUSSINESS: 'business',
  COUPLES: 'couples',
  SOLO: 'solo',
  FAMILY: 'family',
  FRIENDS: 'friends',
  //expedia
  FUN: 'leisure',
  BUSSINESSFUN: 'business_and_leisure',
  FRIENDSFAMILY: 'friends_and_family',
};

export const getReviewIcon = (type: string) => {
  switch (type) {
    case REVİEW_TYPES.BUSSINESS:
    case REVİEW_TYPES.BUSSINESSFUN:
      return BusinessIcon;
    case REVİEW_TYPES.COUPLES:
      return HeartIcon;
    case REVİEW_TYPES.SOLO:
      return ProfileIcon;
    case REVİEW_TYPES.FAMILY:
    case REVİEW_TYPES.FRIENDSFAMILY:
      return FamilyIcon;
    case REVİEW_TYPES.FRIENDS:
      return FriendsIcon;
    case REVİEW_TYPES.FUN:
      return ExpediaFunIcon;

    default:
      return undefined;
  }
};

export const getRating = (type: number) => {
  if (type >= 4.5) {
    return 'Mükemmel';
  } else if (type >= 4 && type < 4.5) {
    return 'Çok iyi';
  } else if (type >= 3 && type < 4) {
    return 'İyi';
  } else if (type < 3) {
    return '';
  }
};

export const getRatingAboveFour = (type: number) => type >= 4;
